
import { defineComponent, onMounted, onUnmounted, ref } from "vue";

export default defineComponent({
  emits: ["modal-close"],
  props: {
    isOpen: {
      type: Boolean,
      default: false
    }
  },

  setup(_, { emit }) {
    const isMouseDown = ref<boolean>(false);

    onMounted(() => {
      document.body.style.overflow = "hidden";
    });

    onUnmounted(() => {
      document.body.style.overflow = "";
    });

    function handleOutsideClick(event) {
      if (isMouseDown.value) {
        isMouseDown.value = false;
        return;
      }

      if (event.target.id === "outside-modal") emit("modal-close");
    }

    function handleMouseDown(event) {
      if (event.target.id === "outside-modal") return;
      isMouseDown.value = true;
    }

    return {
      handleOutsideClick,
      handleMouseDown,
      emit
    };
  }
});
